<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :totalData="totalData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="checkboxChange"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template slot-scope="{ form }">
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('E')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile(form)"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckList" />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <chooseTemplate
      @export-success="clearCheckList"
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import chooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    chooseTemplate,
  },
  data() {
    return {
      usePage: true,
      sortFields: [],
      isAllShipments: 'N',
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'ecom-noShipRecord',
        searchForm: {},
      },
      checkList: [],
      totalData: {},
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkList?.length || 0
    },
  },
  methods: {
    async getData(form) {
      const params = {
        ...form,
        ...this.page,
      }
      this.getTotalData(params)
      this.loading = true
      await this.getTableData(params)
      this.loading = false
    },
    async getTableData(params) {
      const res = await this.$api
        .ecomAmzSkuReportNoShipRecordApi(params)
        .catch(() => null)
      if (res) this.setData(res)
    },
    async getTotalData(params) {
      this.totalData = {}
      const res = await this.$api
        .ecomAmzSkuReportNoShipRecordTotalApi(params)
        .catch(() => null)
      this.totalData = res?.body || {}
    },
    clearCheckList() {
      this.$refs.main.removeCheckboxRow()
      this.checkList = []
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
      }
      this.chooseTemplateOptions.searchForm.checkList = this.checkList
    },
    checkboxChange(data) {
      const tmp = data?.map((e) => e.checkKeyId || '') || []
      this.checkList = tmp.filter((e) => Boolean(e))
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
